"use strict";
/*@__PURE__*/ Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".btnMain[_ngcontent-%COMP%]{padding:9px!important}.globalPadding[_ngcontent-%COMP%]{padding-left:34px;padding-right:34px;padding-top:10px}.borderDiv[_ngcontent-%COMP%]{border-top:1px solid #d3d3d3}.centerText[_ngcontent-%COMP%]{text-align:center!important}.noPaddingMd-12[_ngcontent-%COMP%]{padding-left:0!important;padding-right:0!important}.noBottommargin[_ngcontent-%COMP%]{margin-bottom:0!important}"];
exports.styles = styles;

